// extracted by mini-css-extract-plugin
export var childrenContainer = "_55-0";
export var virtualScrollArea = "_55-1";